@if(viewModel) {
  <div>
    @if(viewModel.scenarios.length === 0 && !viewModel.isFetching){
      <p
        data-testid="no-scenarios"
        class="center"
      >
        No scenarios to display
      </p>
    }

    @if(viewModel.scenarios.length > 0 && !viewModel.isFetching) {
      <span>
        <app-scenarios-result-list [scenarios]="viewModel.scenarios"></app-scenarios-result-list>
      </span>
    }

    @if(viewModel.isFetching){
      <span data-testid="search-scenarios-spinner" class="center">
        <tds-icon
          name="progress_activity"
          class="spinner"
          data-testid="spinner"
        />
        <span class="loading">Loading</span>
      </span>
    }

    @if(viewModel.error) {
      <span data-testid="search-scenarios-error" class="center">{{
          viewModel.error
        }}</span>
    }

  </div>
}

